import * as React from "react";

const ReminderIcon = (props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <path
      fill="var(--menuBarIconActive)"
      d="M20 4.72 15.4.86l-1.29 1.53 4.6 3.86L20 4.72ZM5.88 2.39 4.6.86 0 4.71l1.29 1.53 4.59-3.85ZM10 3a9 9 0 0 0-9 9c0 4.97 4.02 9 9 9a9 9 0 0 0 0-18Zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7Zm-1.46-5.47L6.41 11.4l-1.06 1.06 3.18 3.18 6-6-1.06-1.06-4.93 4.95Z"
    />
  </svg>
);
export default ReminderIcon;
